﻿'use strict';
/**
 * errorLogSvc: global error logging service
 * 
 * errorLogSvc is a global logging service that preserves the default logging behaviour (logging to the console)
 * but also posts the error server side after generating a stacktrace.
**/

var stackTrace = require('stacktrace-js');
var rp = require('request-promise');


// @ngInject 
module.exports = function($log, $window, traceSvc) {
    function error(exception, cause) {
        // preserve the default behaviour which will log the error 
        // to the console, and allow the application to continue running. 
        $log.error.apply($log, arguments);

        // now try to log the error to the server side. 
        var errorMessage = exception.toString();
        // use our traceService to generate a stack trace 
        var stackTrace = traceSvc.print({ e: exception });
        // use AJAX (in this example jQuery) and NOT 
        // an angular service such as $http 
        //console.log($window.location, '$window.location');
        //console.log($window.location.origin, '$window.location.origin');
        var reqOpts = {
            encoding: 'utf8',
            uri: $window.location.origin + '/api/logger',
            method: 'POST',
            json: true,
            body: {
                url: $window.location.href,
                npeId: $location.search()['npeid'],
                message: errorMessage,
                type: "exception",
                stackTrace: stackTrace,
                cause: (cause || "")
            }
        }

        //console.log(reqOpts, 'reqOpts');
        rp(reqOpts).catch(function(loggingError) {
            $log.warn("Error server-side logging failed.");
            $log.log(loggingError);
        });

    }

    return(error);
}